const SummonSection = {
  getters: {
    activeSummonSlide: state => state.activeSlide,
    summonSliderActive: state => state.summonSlider,
  },
  state: {
    activeSlide: 0,
    summonSlider: false,
    summonData: [
      {
        name: 'kardian',
        desc:
          'An ancient dragon from the Elias Royal Family. The King asked you to take care of it and use its powers for difficult battles.',
        icon: '/slide8/summon_slider/summon_kardian.gif',
        image: '/slide8/summon_slider/summon_kardian_expand.png',
      },
      {
        name: 'erazer',
        desc:
          'An electronic golem made by the genius inventory in Atlantis. Erazer can think and grow but it is a prototype.',
        icon: '/slide8/summon_slider/summon_erazer.gif',
        image: '/slide8/summon_slider/summon_erazer_expand.png',
      },
      {
        name: 'lustral',
        desc:
          'An electronic golem made by the genius inventory in Atlantis. Erazer can think and grow but it is a prototype.',
        icon: '/slide8/summon_slider/summon_lustral.gif',
        image: '/slide8/summon_slider/summon_lustral_expand.png',
      },
      {
        name: 'beatrice',
        desc:
          'Beatrice was born in Devildom which was destroyed by Lux shortly after her birth. When Priests of the Temple of Seres discovered her, they wanted to guide her towards a good path.',
        icon: '/slide8/summon_slider/summon_beatrice.gif',
        image: '/slide8/summon_slider/summon_beatrice_expand.png',
      },
      {
        name: 'richiring',
        desc:
          'Mysterious Priring that was raised by the great merchants of Riveria. He loves money and investments!',
        icon: '/slide8/summon_slider/summon_richiring.gif',
        image: '/slide8/summon_slider/summon_richiring_expand.png',
      },
      {
        name: 'yunia',
        desc:
          "Adrica's summonable favored by the goddess Gaia. Dragon King Atkina had to save Yunia in the past.",
        icon: '/slide8/summon_slider/summon_yunia.gif',
        image: '/slide8/summon_slider/summon_yunia_expand.png',
      },
    ],
  },
  mutations: {
    'SUMMON_SECTION/OPEN_SLIDER': function(state, slideID) {
      state.summonSlider = true;
      state.activeSlide = slideID;
    },
    'SUMMON_SECTION/CLOSE_SLIDER': function(state) {
      state.summonSlider = false;
    },
  },
};

export default SummonSection;
